import { renderStringToReact, useTranslation } from '@web_opxp/features';
import { FC } from 'react';
import { getDomainIconSrc } from '../../assets';
import { EDomain } from '../../base/types';
import HintPopup from '../../components/HintPopup/HintPopup';
import './DomainEvaluation.scss';
import DomainProgress from './DomainProgress';
import MoodProgress from './MoodProgress';

export interface IDomainEvaluationOwnProps {
  domain: EDomain;
}

export const DomainEvaluation: FC<IDomainEvaluationOwnProps> = ({ domain }) => {
  const { t } = useTranslation();

  const domainIcon = getDomainIconSrc(domain);

  const isMoodDomain = domain === EDomain.Mood;

  const domainTitle = t(`common:Domain.Title.${domain}`);

  const domainString = domain ? EDomain[domain] : EDomain[EDomain.Assessment];

  const buttonLabel = t(`Evaluation.HintDialogOKLabel.${domainString}`);
  const hintPopupTitle = t(`Evaluation.HintDialogTitle.${domainString}`);
  const hintPopupContent = t(`Evaluation.HintContentHtml.${domainString}`);

  const contentReactElement = renderStringToReact(hintPopupContent);

  return (
    <div className={`self-evaluation-domain-evaluation domain-${domain}`}>
      <h2>
        <img src={domainIcon} alt={domainTitle} className="domain-icon" />
        {domainTitle}
        <HintPopup title={hintPopupTitle} iconSize={20} okButtonLabel={buttonLabel}>
          {contentReactElement}
        </HintPopup>
      </h2>
      <p>{t(`Evaluation.SelfAssessments.Descriptions.${domain}`)}</p>
      {isMoodDomain ? <MoodProgress /> : <DomainProgress domain={domain} />}
    </div>
  );
};

export default DomainEvaluation;
